import { RENTAL_MANAGER_PATH } from '../constants/routeConstants';
import axios from 'axios';

declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean;
  }
}

export const setCookiesFromSearch = () => {
  const urlParams = new URLSearchParams(window.location.search);

  const allowedCookies = [];
  const leasingPath = `/${RENTAL_MANAGER_PATH}`;

  urlParams.forEach((value: string, key: string) => {
    if (allowedCookies.indexOf(key.toUpperCase()) !== -1) {
      document.cookie = `${key}=${value};path=${leasingPath}`;
    }
  });
};

export const getNameFromContentDisposition = (contentDisposition: string, fallbackFilename = 'file'): string => {
  let filename = fallbackFilename;

  try {
    filename = contentDisposition.match(/filename[^;=\n]*=((['"])?(.*)?\2|[^;\n]*)/)[3];
  } catch (err) {
    // Ignore
  }

  return filename;
};

export const downloadFileFromUrl = async (url: string, fallbackFilename = 'file') => {
  if ('IS_IN_TEST_ENVIRONMENT' in global) {
    console.info(
      `We're in a test environment so downloadFileFromUrl behavior has been short-circuited. download URL: ${url} `,
    );
    return;
  }

  const response = await axios({
    url,
    method: 'GET',
    responseType: 'blob',
    withCredentials: true,
  });

  const blob = new Blob([response.data]);
  const filename = getNameFromContentDisposition(response.headers['content-disposition'], fallbackFilename);

  // For IE and Edge support
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, filename);
  } else if (window['URL']) {
    const href = window['URL'].createObjectURL(blob);
    const link = document.createElement('a');

    link.href = href;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return { filename, response };
};

export function getCookie(name: string): string {
  if (typeof document === 'undefined') {
    return null;
  }

  const cookieString = RegExp(name + '[^;]+').exec(document.cookie);
  return decodeURIComponent(cookieString ? cookieString.toString().replace(/^[^=]+./, '') : '');
}

export function putNodeIdInSearch(nodeId: string, updateFunction: (path: string) => void) {
  const { pathname, search } = window.location;
  const urlParams = new URLSearchParams(search);

  if (urlParams.get('nodeId') !== nodeId) {
    urlParams.set('nodeId', nodeId);
    updateFunction(`${pathname}?${urlParams.toString()}`);
  }
}

export function getRenterInboxByConversationIdPath(conversationId: string) {
  return conversationId ? `/renter-hub/inbox/${conversationId}` : '/renter-hub/inbox';
}
